<app-alert></app-alert>
<app-floating-tips></app-floating-tips>


<div id='general-div' class='general-div'>
  <router-outlet (activate)="changeOfRoutes()"></router-outlet>
</div>